import { render, staticRenderFns } from "./CenterViewTemplate_Ap.vue?vue&type=template&id=7230f59b&scoped=true"
import script from "./CenterViewTemplate_Ap.vue?vue&type=script&lang=js"
export * from "./CenterViewTemplate_Ap.vue?vue&type=script&lang=js"
import style0 from "./CenterViewTemplate_Ap.vue?vue&type=style&index=0&id=7230f59b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7230f59b",
  null
  
)

export default component.exports